import React, { Component } from 'react';
import MagazineArticleMeta from '../article/magazine-article-meta';

export default class MagazineItem extends Component {
	renderTagList( post ) {
		if ( 'undefined' !== typeof post.tags && post.tags ) {
			return (
			<div className="tag-list">
				<p className="tag-list-heading">Tags:</p>
				<p className="default-tags-list" dangerouslySetInnerHTML={ { __html: post.tags } } />
			</div>
		);
	} else {
		return null;
	}
}

render() {
	let post = this.props.post;

		if ( 'undefined' !== typeof post.id ) {
			return (
				<div className="col-sm-6 col-lg-3">
					<article id={ `post-${post.id}` } className={ this.props.classes }>
						<header className="entry-header">
							<MagazineArticleMeta post={ post } ind={ this.props.ind } />
							<h2 className="entry-title">
								<a href={ post.link } dangerouslySetInnerHTML={ { __html: post.trimmed_title } } />
							</h2>
						</header>
						{ /* @todo: Why does this render tag IDs instead of HTML on magazine view? */ }
						{ this.renderTagList( post ) }
					</article>
				</div>
			);
		} else {
			return (
				<div className="col-sm-6 col-lg-3">
					<article id="post-" className={ this.props.classes }></article>
				</div>
			);
		}
	}
}